import { createSlice } from "@reduxjs/toolkit";

export const showSpinnerSlice = createSlice({
  name: "showSpinner",
  initialState: {
    value: false,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { update } = showSpinnerSlice.actions;

export default showSpinnerSlice.reducer;
